export enum MOBILE_FONT_SIZE {
  h1 = 1.5,
  h2 = 1.375,
  h3 = 1.25,
  h4 = 1.125,
  h5 = 1,
  h6 = 0.875,
  subtitle1 = 0.875,
  body1 = 1,
  body2 = 0.875,
  button = 0.875,
  caption = 0.875,
  overline = 0.75,
}
